import { render, staticRenderFns } from "./ReturnShipmentOptions.vue?vue&type=template&id=faba49ee&scoped=true"
import script from "./ReturnShipmentOptions.vue?vue&type=script&lang=ts"
export * from "./ReturnShipmentOptions.vue?vue&type=script&lang=ts"
import style0 from "./ReturnShipmentOptions.vue?vue&type=style&index=0&id=faba49ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faba49ee",
  null
  
)

export default component.exports